import React, { memo } from 'react';
import Modal from './modal.base';

const ModalUserInfo = memo(({ open, setOpen, children, title }) => {
  return (
    <Modal open={open} setOpen={setOpen} title={title}>
      {children}
    </Modal>
  );
});

export default ModalUserInfo;
